import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Siren, FileText } from "lucide-react";
import { PetAvatar } from "@/components/PetAvatar";
import { api } from "@/lib/api";

export default function Pets() {
  const [pets, setPets] = useState(null);
  useEffect(() => { api.get("/pets").then((r) => setPets(r.data)); }, []);
  return (
    <div data-testid="pets-page">
      <div className="flex items-center justify-between mb-5">
        <h1 className="font-heading text-4xl font-extrabold">Pets</h1>
        <Link to="/app/pets/new" className="pl-btn-primary !min-h-[44px]" data-testid="pets-add-btn"><Plus className="h-4 w-4" />Add pet</Link>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        {pets?.map((p) => (
          <Link key={p.id} to={`/app/pets/${p.id}`} data-testid={`pet-card-${p.id}`} className="pl-card overflow-hidden group">
            <div className="h-44 bg-[#FFF7E6] grid place-items-center overflow-hidden">
              {p.photo_url ? <PetAvatarCover pet={p} /> : <PetAvatar pet={p} size={96} />}
            </div>
            <div className="p-4">
              <p className="font-heading text-2xl font-bold">{p.name}</p>
              <p className="text-sm text-slate-500 capitalize">{[p.species, p.breed].filter(Boolean).join(" · ")}</p>
            </div>
          </Link>
        ))}
      </div>
      {pets?.length === 0 && <p className="text-slate-500" data-testid="pets-empty">No pets yet. Add every pet you have: it's the same price.</p>}
      {pets?.length > 0 && (
        <div className="grid grid-cols-2 gap-3 mt-6">
          <Link to="/app/emergency" className="pl-btn-ghost" data-testid="pets-emergency-btn"><Siren className="h-4 w-4 text-[#E07A5F]" />Emergency cards</Link>
          <Link to="/app/guide" className="pl-btn-ghost" data-testid="pets-guide-btn"><FileText className="h-4 w-4" />Sitter guide</Link>
        </div>
      )}
    </div>
  );
}

function PetAvatarCover({ pet }) {
  return <img src={`${process.env.REACT_APP_BACKEND_URL}${pet.photo_url}`} alt={pet.name} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />;
}
